var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 105,
    viewBox: "0 0 162 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2877 78.4948L55.4558 58.4179L62.1212 51.843L73.7152 63.5604L97.7716 25.8252L105.681 30.8503L75.2877 78.4948Z",
    fill: "#3AA30D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5696 104.02C51.9835 104.02 28.725 80.7494 28.725 52.1486C28.725 23.5478 51.9835 0.277344 80.5696 0.277344C109.156 0.277344 132.414 23.5478 132.414 52.1486C132.414 80.7494 109.156 104.02 80.5696 104.02ZM80.5696 7.32188C55.856 7.32188 35.7659 27.4223 35.7659 52.1486C35.7659 76.8749 55.856 96.9753 80.5696 96.9753C105.283 96.9753 125.373 76.8749 125.373 52.1486C125.373 27.4223 105.283 7.32188 80.5696 7.32188Z",
    fill: "#3AA30D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3937 50.9746H-0.00244141V53.3228H15.3937V50.9746Z",
    fill: "#3AA30D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0838 18.3054L8.42426 19.9658L19.311 30.8581L20.9705 29.1977L10.0838 18.3054Z",
    fill: "#3AA30D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.288 72.9241L8.40134 83.8164L10.0609 85.4768L20.9476 74.5845L19.288 72.9241Z",
    fill: "#3AA30D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.116 50.9746H145.72V53.3228H161.116V50.9746Z",
    fill: "#3AA30D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.063 18.3362L140.176 29.2285L141.836 30.8889L152.722 19.9966L151.063 18.3362Z",
    fill: "#3AA30D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.838 72.9079L140.178 74.5684L151.065 85.4607L152.725 83.8002L141.838 72.9079Z",
    fill: "#3AA30D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.213e13a72c2ec9d87e40411f30a57f17.svg";
export { ForwardRef as ReactComponent };